/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { DepartmentsService } from '../../services/departments.service';
import { AppService } from '../../api.service';
import {  Router } from '@angular/router';
import { LocalStorageService } from '../../services/localstorage.service';

@Component({
  selector: 'app-global-department',
  templateUrl: './global-department.component.html',
  styleUrls: ['./global-department.component.scss']
})
export class GlobalDepartmentComponent {
constructor(public _ds: DepartmentsService,private _as:AppService,private _router:Router,private localStorageService: LocalStorageService){

}
onDepartCategory(slug_name:string){
   
  const url = this._as.api_base_url + "home/department-count/" +JSON.parse(this.localStorageService.getItem('uuid') || '')+"/";
  const data = {
    slug_name:slug_name
  }
  this._as.putRequest(url,data, true)
    .subscribe((res: any) => {
      // this.updatedRecentlyViewedProducts()
      console.log(res);
    });
    this._router.navigate(['department/'+slug_name])
}
getURL(slug_name:string){

  return 'department/'+slug_name
}
getColor(){
  if (this._router.url.split('/')[1].split('?')[0] == "smart-search") {
    return true
  } else {
    return false
  }
}
}
